import api from "../api";

const endpoint = "/api/usuarios";

function logar(usuario) {
  usuario = usuario || {};
  return new Promise((resolve, reject) => {
    return api
      .post("/api/usuarios/login", {
        login: usuario.login,
        senha: usuario.senha,
      })
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
}

const obterTodos = async () => {
  return new Promise((resolve, reject) => {
    return api
      .get(endpoint)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
};

const obterPorId = async (id) => {
  return new Promise((resolve, reject) => {
    return api
      .get(`${endpoint}/${id}`)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
};

const cadastrar = async (usuario) => {
  return new Promise((resolve, reject) => {
    return api
      .post(endpoint, usuario)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
};

const atualizar = async (id, usuario) => {
  return new Promise((resolve, reject) => {
    return api
      .put(`${endpoint}/${id}`, usuario)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
};

const inativar = async (id) => {
  return new Promise((resolve, reject) => {
    return api
      .put(`${endpoint}/inativar/${id}`)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
};

const ativar = async (id) => {
  return new Promise((resolve, reject) => {
    return api
      .put(`${endpoint}/ativar/${id}`)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
};

export default {
  logar,
  obterTodos,
  obterPorId,
  cadastrar,
  atualizar,
  inativar,
  ativar,
};
